import { render, staticRenderFns } from "./EventsArea.vue?vue&type=template&id=6a0a424c&scoped=true&"
import script from "./EventsArea.vue?vue&type=script&lang=js&"
export * from "./EventsArea.vue?vue&type=script&lang=js&"
import style0 from "./EventsArea.vue?vue&type=style&index=0&id=6a0a424c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a424c",
  null
  
)

export default component.exports